export default "__VITE_ASSET__CTtEQlE3__"